import { render, staticRenderFns } from "./gotop.vue?vue&type=template&id=3c21da49&scoped=true"
import script from "./gotop.vue?vue&type=script&lang=js"
export * from "./gotop.vue?vue&type=script&lang=js"
import style0 from "./gotop.vue?vue&type=style&index=0&id=3c21da49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c21da49",
  null
  
)

export default component.exports